import React from "react";
import { motion } from "framer-motion";

// Shared easing + timing for a cohesive feel across the site
const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.7, ease: EASE } },
};

// Parent that staggers its children's reveal
export const staggerContainer = (stagger = 0.12, delayChildren = 0) => ({
  hidden: {},
  visible: {
    transition: { staggerChildren: stagger, delayChildren },
  },
});

/**
 * Reveal — wraps content and animates it in when it scrolls into view.
 * Usage: <Reveal><h2>...</h2></Reveal>
 */
export const Reveal = ({ children, variants = fadeUp, className, as = "div", once = true, amount = 0.2, ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

/**
 * StaggerGroup — reveals a set of children one after another on scroll.
 * Wrap each child in <Reveal> (or a motion element using the same variants).
 */
export const StaggerGroup = ({ children, className, stagger = 0.12, delayChildren = 0, once = true, amount = 0.15, as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={staggerContainer(stagger, delayChildren)}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
